module.exports = __webpack_public_path__ + "static/media/se_1.73c8d701.wav";